
window.getDropdowns = function() {

  const openElements = document.querySelectorAll('[data-toggle="show-dropdown"]')

  openElements.forEach((toggleElement) => {
    toggleElement.addEventListener("click", () => {
      var windowSelector = toggleElement.getAttribute("data-target")
      var windowElements = document.querySelectorAll(windowSelector)
      windowElements.forEach((windowElement) => {
        windowElement.classList.remove("hidden")
        windowElement.classList.add("shown")
      })
    })
  })

  const closeElements = document.querySelectorAll('[data-close="dropdown"]')

  closeElements.forEach((closeElement) => {
    closeElement.addEventListener("click", () => {
      var goalElementSelector = closeElement.getAttribute("data-target")
      var goalElements = document.querySelectorAll(goalElementSelector)

      goalElements.forEach((dropdownItem) => {
        dropdownItem.classList.remove("shown")
        dropdownItem.classList.add("hidden")
      })

    })
  })
}

window.getCollapses = function () {
  const collapseLists = document.querySelectorAll('[data-my-toggle="collapse-list"]')
  collapseLists.forEach((listItem) => {
    var toggleSelector = listItem.getAttribute("data-my-target")
    var className = `${toggleSelector.slice(1, toggleSelector.length)}--expanded`
    var clickItems = listItem.querySelectorAll(toggleSelector)

    clickItems.forEach((elementItem) => {
      elementItem.addEventListener("click", () => {
        if (elementItem.classList.contains(className)) {
          elementItem.classList.remove(className)
        }
        else {
          elementItem.classList.add(className)
        }
      })
    })
  })
}

window.countdownTimer = function (domElement) {
  var today = new Date()
  var countDownDate = new Date(
    today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59).getTime()

  var clockItems = domElement.querySelectorAll(".clock-tail .clock-tail__value")

  setInterval(() => {
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24))
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    var seconds = Math.floor((distance % (1000 * 60)) / 1000)

    clockItems[0].innerHTML = days
    clockItems[1].innerHTML = hours
    clockItems[2].innerHTML = minutes
    clockItems[3].innerHTML = seconds

  }, 1000)
}